import React from "react";
import { useSelector } from "react-redux";
import { i18n } from '../../../translate/i18n';
import {
  Paper, Typography, Divider,
} from '@mui/material';
import { FormStyled } from './styles'
import { isEmpty } from 'lodash';
import Spinner from "../../../components/Spinner";
import AttachmentsViewerWithoutModal from "../../../UI/AttachmentsViewer/AttachmentsViewerWithoutModal";

export default function ListEquipmentModelsByEquipment(props) {
  const styles = {
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      textAlign: 'center'
    },
    headerButtonsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  };

  // get from redux
  const selectedAccess = useSelector((state) => state.auth.selectedAccess)
  const loading = useSelector((state) => state.equipments.loading);
  const loadingEquipments = useSelector(state => state.equipments.loading);
  const role = selectedAccess.role;
  
  const attachmentsEquipmentModel = useSelector((state) => state.equipmentModels.equipmentModel.attachments);

  return (
    <Paper>
      <FormStyled style={{ opacity: loadingEquipments ? '0.3' : '1' }}>
        <div style={styles.headerButtonsContainer}>
          <Typography variant='h6' style={{ padding: '20px 20px 20px 0' }}>
            {
              i18n.t('attachmentFilesEquipmentModelsTypo.label')
            }
          </Typography>
        </div>
        <Divider style={{marginBottom: 10}}/>
        {loading &&
          <div>
            <Spinner overlay />
          </div>
        }

        { isEmpty(attachmentsEquipmentModel) ?
          <div style={styles.noResults}>
            <Typography>{i18n.t('attachmentFilesEquipmentModelsTypo.noResults')}</Typography>
          </div>
          :
          <div style={styles.noResults}>
            
            <AttachmentsViewerWithoutModal role={role} attachments={attachmentsEquipmentModel} />
             
          </div>
        }
      </FormStyled>
    </Paper>
  );

}
